//#region types
import { FormEnums } from "models/enums";
import { FormFieldConstants, IconDefinitionConstants } from "utils/constants";
import { GenericFormSection } from "models/propTypes/genericFormProps";
import { TranslationKeys } from "translations";
import { BusinessUnitFormTypes } from "models/formTypes";
import { FilterQueryStateHandler } from "models/propTypes/filterPropTypes";
//#endregion
//#region components
//#endregion
import { QueryStateHelper } from "utils/helpers";

function useBusinessUnitProfileFilterDefinition() {
  const filterFormFields: GenericFormSection<BusinessUnitFormTypes.Filter>[] = [
    {
      label: TranslationKeys.Common.Filter,
      type: FormEnums.FormSectionType.EXPANDABLESECTION,
      icon: IconDefinitionConstants.WSliders,
      innerFields: {
        period: {
          label: TranslationKeys.Common.Date,
          type: FormEnums.FormFieldType.MONTH,
        },
      },
    },
  ];

  const filterQueryStateHandler: FilterQueryStateHandler<BusinessUnitFormTypes.Filter> = {
    period: QueryStateHelper.monthQueryEncoder(FormFieldConstants.BusinessUnit.Filter.Period),
  };

  return { filterFormFields, filterQueryStateHandler };
}

export default useBusinessUnitProfileFilterDefinition;
